import React, { Component } from "react"
import _ from "lodash"
import path from "path"
import styles from "./styles.css"
import FontIcon from "react-toolbox/lib/font_icon/FontIcon"

export default class FileList extends Component {
  props: {
    files: Object[],

    onFileDelete: any,
    onFileClick: any,
  }

  getFileList () {
    return _.get( this.props, "files", [] )
      .map( file => {
        if ( ( !file.name || !file.ext ) && file.path ) {
          return {
            ...file,
            name: path.basename( file.path ),
            ext: path.extname( file.path ),
          }
        }

        return file
      } )
  }

  render () {
    const { onFileDelete, onFileClick } = this.props
    const fileList = this.getFileList()

    return (
      <div className={styles.fileList}>
        <table>
          <tbody>
            {fileList.map( file => (
              <tr
                key={file.name}
                className={styles.file}
                onClick={() => onFileClick( file )}
              >
                <td>
                  { onFileDelete ? (
                    <FontIcon
                      className={styles.deleteIcon}
                      value="delete"
                      onClick={() => onFileDelete( file )}
                    />
                  ) : null }
                </td>
                <td className={styles.fileExt}>
                  <span className={styles.fileExtInner}>{file.ext}</span>
                </td>
                <td/>
                <td>{file.name}</td>
              </tr>
            ) )}
          </tbody>
        </table>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FormikComponents/FilePicker/FileList.jsx